import { makeAutoObservable, runInAction } from 'mobx';

import http from '../helpers/http';

import User from './models/User';

export default class AuthStore {
    isProcess = true;

    page = '';

    user: User | null = null;

    id!: string;
    token!: string;
    status!: string;

    get isAuthenticated() {
        return !!this.id && !!this.token && this.status !== 'unconfirmed';
    }

    constructor() {
        makeAutoObservable(this);
    }

    async authenticate() {
        try {
            this.isProcess = true;

            http.defaults.headers.Authorization = `Bearer ${localStorage.getItem('auth:token')}`;

            const { data } = await http.get('/auth/authenticate');

            runInAction(() => {
                this.id = data.id;
                this.token = data.token;
                this.status = data.status;

                http.defaults.headers.Authorization = `Bearer ${this.token}`;

                localStorage.setItem('auth:token', this.token);
            });
        } finally {
            this.isProcess = false;
        }
    }

    async login(email: string, password: string) {
        try {
            this.isProcess = true;

            const { data } = await http.post('/auth/login', {
                email,
                password,
            });

            runInAction(() => {
                this.id = data.id;
                this.token = data.token;
                this.status = data.status;

                http.defaults.headers.Authorization = `Bearer ${this.token}`;

                localStorage.setItem('auth:token', this.token);
            });
        } finally {
            this.isProcess = false;
        }
    }

    async loginFacebook(id: string, token: string) {
        try {
            this.isProcess = true;

            const { data } = await http.post('/auth/connect/facebook', {
                id,
                token,
            });

            runInAction(() => {
                this.id = data.id;
                this.token = data.token;
                this.status = data.status;

                http.defaults.headers.Authorization = `Bearer ${this.token}`;

                localStorage.setItem('auth:token', this.token);
            });
        } finally {
            this.isProcess = false;
        }
    }

    async loginGoogle(id: string, token: string) {
        try {
            this.isProcess = true;

            const { data } = await http.post('/auth/connect/google', {
                id,
                token,
            });

            runInAction(() => {
                this.id = data.id;
                this.token = data.token;
                this.status = data.status;

                http.defaults.headers.Authorization = `Bearer ${this.token}`;

                localStorage.setItem('auth:token', this.token);
            });
        } finally {
            this.isProcess = false;
        }
    }

    async signup(email: string, password: string) {
        try {
            this.isProcess = true;

            await http.post('/auth/signup', {
                email,
                password,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async confirm(email: string) {
        try {
            this.isProcess = true;

            await http.post('/auth/request/confirm', {
                email,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async confirmVerify(email: string, code: string) {
        try {
            this.isProcess = true;

            await http.post('/auth/verify/confirm', {
                email,
                code,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async recovery(email: string) {
        try {
            this.isProcess = true;

            await http.post('/auth/request/recovery', {
                email,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async recoveryVerify(email: string, code: string) {
        try {
            this.isProcess = true;

            await http.post('/auth/verify/recovery', {
                email,
                code,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async recoveryReset(email: string, password: string, code: string) {
        try {
            this.isProcess = true;

            await http.post('/auth/verify/password', {
                email,
                password,
                code,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async logout() {
        try {
            this.isProcess = true;

            await http.post('/auth/logout');
        } finally {
            runInAction(() => {
                this.id = '';
                this.token = '';
                this.status = '';

                localStorage.removeItem('auth:token');

                http.defaults.headers.Authorization = `Bearer ${this.token}`;

                this.isProcess = false;
            });
        }
    }
}
